import React, { memo } from "react";
import PropTypes from "prop-types";
import { SvgIcon } from "@mui/material";

const NavigateCircleIcon = ({ className, width, height }) => {
  return (
    <SvgIcon sx={{ width: width, height: height }} className={className} viewBox="0 0 512 512" fill="currentColor">
      <g id="SVGRepo_bgCarrier" strokeWidth="0" />

      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />

      <g id="SVGRepo_iconCarrier">
        <path d="M336.76,161,150.23,243.35c-10.47,4.8-6.95,20.67,4.57,20.67H244a4,4,0,0,1,4,4V357.2c0,11.52,16,15,20.78,4.56L351,175.24A10.73,10.73,0,0,0,336.76,161Z" />

        <path
          d="M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z"
          style={{ fill: "none", stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 32 }}
        />
      </g>
    </SvgIcon>
  );
};
NavigateCircleIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};
NavigateCircleIcon.defaultProps = {
  width: 24,
  height: 24,
};

export default memo(NavigateCircleIcon);
